module.exports = __webpack_public_path__ + "img/p2-0.5ec088e1.png";